// Shared selector functions:
export const getAgencyAndEntityTypes = state => ({
  agency_type: state.dataTypes.agency_type,
  map_type: state.dataTypes.map_type
});
